import { useMemo, useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import exit from '~/assets/icons/exit.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Apps } from '~/shared';
import messageIcon from '../../assets/icons/apps/message.svg';
import { returnToLauncher, useLayoutDispatch } from '../../redux';
import { LoadingScreen } from '../LoadingScreen';
import { getAppLoadingInfo } from '../TabletApp';
import { TextLabel } from '../TextLabel';
import {
	AppMessageMenu,
	appMessageMenuIcons,
	appMessageMenuNames,
	appMessageTabs,
} from './AppMessage.model';
import {
	StyledContainer,
	StyledExitButton,
	StyledIconContainer,
	StyledLayoutContainer,
	StyledLeftContainer,
	StyledMenuContainer,
	StyledMenuItemContainer,
	StyledWrapper,
} from './AppMessage.styled';

const AppMessage = () => {
	const dispatch = useLayoutDispatch();
	const loadingInfo = getAppLoadingInfo(Apps.Message);
	const [loading, setLoading] = useState(true);
	const [activeTab, setActiveTab] = useState(AppMessageMenu.Messages);

	const ActiveTab = useMemo(() => appMessageTabs[activeTab], [activeTab]);

	useEffectOnce(() => {
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	});

	return (
		<StyledWrapper>
			<SwitchTransition>
				<CSSTransition
					timeout={300}
					key={loading ? 0 : 1}
					classNames={'loading'}
					addEndListener={(node, done) =>
						node.addEventListener('transitionend', done, false)
					}
				>
					{loading ? (
						<LoadingScreen
							icon={loadingInfo.loadingIcon}
							text={loadingInfo.loadingMessage}
							color={loadingInfo.color}
							name={loadingInfo.name}
						/>
					) : (
						<StyledContainer>
							<StyledLayoutContainer>
								<StyledLeftContainer>
									<StyledIconContainer>
										<img src={messageIcon} />
									</StyledIconContainer>
									<StyledMenuContainer>
										{Object.values(AppMessageMenu).map((item) => (
											<StyledMenuItemContainer
												key={item}
												$active={activeTab === item}
												onClick={() => {
													setActiveTab(item);
													playSound(Sound.ClickButton);
												}}
												onMouseEnter={() => playSound(Sound.LinkCursor)}
											>
												<img src={appMessageMenuIcons[item]} />
												<TextLabel>{appMessageMenuNames[item]}</TextLabel>
											</StyledMenuItemContainer>
										))}
										<StyledExitButton
											src={exit}
											onClick={() => {
												dispatch(returnToLauncher());
												playSound(Sound.ClickButton);
											}}
											onMouseEnter={() => playSound(Sound.LinkCursor)}
										/>
									</StyledMenuContainer>
								</StyledLeftContainer>
								<SwitchTransition>
									<CSSTransition
										timeout={300}
										key={activeTab}
										classNames={'tab'}
										addEndListener={(node, done) =>
											node.addEventListener('transitionend', done, false)
										}
									>
										<ActiveTab />
									</CSSTransition>
								</SwitchTransition>
							</StyledLayoutContainer>
						</StyledContainer>
					)}
				</CSSTransition>
			</SwitchTransition>
		</StyledWrapper>
	);
};

export { AppMessage };
